/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notif_Type_Packing_ConfirmedInputs */

const vi_notif_type_packing_confirmed = /** @type {(inputs: Notif_Type_Packing_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã đóng gói xong`)
};

/**

* @param {Notif_Type_Packing_ConfirmedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const notif_type_packing_confirmed = /** @type {((inputs?: Notif_Type_Packing_ConfirmedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notif_Type_Packing_ConfirmedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_notif_type_packing_confirmed(inputs)
});